import type { Maybe } from '@adornis/base/utilTypes';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators';
import { nonOptional } from '@adornis/validation/functions/nonOptional';

@Entity()
export class ProductRegistration extends AdornisEntity {
  static override _class = 'ProductRegistration';

  @validate(nonOptional())
  @Field(type => String)
  productID!: string;

  // state
  @validate(nonOptional())
  @Field(type => String)
  state!: string;

  // country
  @validate(nonOptional())
  @Field(type => String)
  country!: string;

  // school type
  @validate(nonOptional())
  @Field(type => String)
  schoolType!: string;

  // accepted conditions of participation
  @validate(nonOptional())
  @Field(type => Boolean)
  acceptedConditionsOfParticipation!: boolean;

  // accepted privacy
  @validate(nonOptional())
  @Field(type => Boolean)
  acceptedPrivacy!: boolean;

  // fields to be set on contact
  @Field(type => [String], { default: v => v ?? [] })
  communicationCampaigns!: string[];

  @Field(type => Boolean)
  isWebinar: Maybe<boolean>;

  @Field(type => Boolean)
  isNewsletter: Maybe<boolean>;
}
